<template>
  <LoadingState
    v-if="!method"
    :loading="true"
  />
  <v-layout
    v-else
    row
    wrap
    color="transparent"
  >
    <v-flex xs12>
      <translations-tabs
        class="pb-4"
      >
        <template #default="{language}">
          <v-layout
            row
            wrap
          >
            <v-flex x12>
              <translatable
                :language="language"
                v-model="method"
                field-name="name"
              >
                <template
                  #default="{ fieldValue, fieldMutator }"
                >
                  <v-text-field
                    v-model="fieldValue"
                    :error-messages="method.displayErrors('name')"
                    :label="$t('Name')"
                    outline
                    @change="fieldMutator(fieldValue)"
                  />
                </template>
              </translatable>
            </v-flex>
            <v-flex xs12>
              <translatable
                :language="language"
                v-model="method"
                field-name="description"
              >
                <template
                  #default="{ fieldValue, fieldMutator }"
                >
                  <v-text-field
                    v-model="fieldValue"
                    :error-messages="method.displayErrors('description')"
                    :label="$t('Description')"
                    outline
                    @change="fieldMutator(fieldValue)"
                  />
                </template>
              </translatable>
            </v-flex>
          </v-layout>
        </template>
      </translations-tabs>
    </v-flex>

    <v-flex xs12>
      <v-text-field
        v-model="method.account_number"
        :error-messages="method.displayErrors('account_number')"
        :label="$t('Account number')"
        outline
      />
    </v-flex>

    <v-flex xs12>
      <v-layout align-start>
        <v-flex>
          <v-switch
            v-model="method.testMode"
            :label="$t('Test mode')"
          />
        </v-flex>
        <v-flex>
          <v-switch
            v-model="method.paid_to_account"
            :label="$t('Paid to account')"
          />
        </v-flex>
        <v-flex v-if="method.isOffline()">
          <v-switch
            v-model="method.auto_pay"
            :label="$t('Automatically Pay')"
          />
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <v-text-field
        v-model.number="method.order"
        :error-messages="method.displayErrors('order')"
        :label="$t('Order')"
        type="number"
        outline
      />
    </v-flex>

    <v-flex xs12>
      <application-select v-model="method.application"/>
    </v-flex>

    <v-flex xs12>
      <image-upload v-model="method.image"/>
    </v-flex>
  </v-layout>
</template>

<script>
import ApplicationSelect from '@/components/form/ApplicationSelect'
import ImageUpload from '@/components/ImageUpload'
import TranslationsTabs from '@/components/widgets/TranslationsTabs'
import Translatable from '@/components/widgets/Translatable'
import LoadingState from '@/components/LoadingState'

export default {
  name: 'PaymentBankTransfer',
  components: { Translatable, TranslationsTabs, ImageUpload, ApplicationSelect, LoadingState },
  props: {
    method: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      schema: {
        'code': '',
        'name': '',
        'enabled': true,
        'application': null,
        'testMode': true,
        'account_number': '',
        'paid_to_account': true,
        'description': '',
        'image': '',
        'order': null,
        'auto_pay': false
      }
    }
  },

  created () {
    this.$emit('setPaymentData', {
      schema: this.schema
    })
  }
}
</script>
